/**
 * 管理员角色的名称与标签色（antd 预设色名）
 */
import dayjs from 'dayjs'

export const ROLE_OPTIONS = [
  { value: 'super_admin', label: '超级管理员' },
  { value: 'content_admin', label: '内容管理员' },
  { value: 'data_analyst', label: '数据分析师' },
  { value: 'operator', label: '运营人员' }
]

const ROLE_COLORS: Record<string, string> = {
  super_admin: 'red',
  content_admin: 'orange',
  data_analyst: 'blue',
  operator: 'green'
}

export function roleColor(role: string): string {
  return ROLE_COLORS[role] || 'default'
}

export function roleName(role: string): string {
  return ROLE_OPTIONS.find((option) => option.value === role)?.label || role
}

export function formatAdminTime(value: string): string {
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
}
